export default "__VITE_ASSET__DaHIM0YB__"